export default __webpack_public_path__ + "static/media/Recruiter.afb66cb7.jpg";